"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import type { MemesExtendedData, NFT } from "@/entities/INFT";
import { parseNftDescriptionToHtml } from "@/helpers/Helpers";
import { ChevronDownIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { MemeArtworkDetails, MemeCardFileType, MemeEditionSizeStats, MemeNftLivePanel } from "./MemePageLiveStats";
const MemePageArt = dynamic(() => import("./MemePageArt").then(mod => mod.MemePageArt));
export function MemePageLiveRightMenu(props) {
  const $ = _c(11);
  if (props.show && props.nft) {
    let t0;
    if ($[0] !== props.nft) {
      t0 = <MemeArtworkDetails nft={props.nft} />;
      $[0] = props.nft;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== props.nftMeta) {
      t1 = props.nftMeta && <MemeEditionSizeStats nftMeta={props.nftMeta} />;
      $[2] = props.nftMeta;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== props.nft) {
      t2 = <MemeNftLivePanel nft={props.nft} />;
      $[4] = props.nft;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
      t3 = <div className="tw-w-full">{t0}{t1}{t2}</div>;
      $[6] = t0;
      $[7] = t1;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t0;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[10] = t0;
  } else {
    t0 = $[10];
  }
  return t0;
}
export function MemePageLiveSubMenu(props) {
  const $ = _c(10);
  if (props.show) {
    let t0;
    if ($[0] !== props.nft) {
      t0 = props.nft && <><MemePageCardDescription nft={props.nft} /><MemeCardFileType nft={props.nft} /></>;
      $[0] = props.nft;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== props.defaultAdditionalDetailsOpen || $[3] !== props.nft || $[4] !== props.nftMeta) {
      t1 = props.nft && props.nftMeta && <MemePageAdditionalDetailsAccordion key={props.defaultAdditionalDetailsOpen ? "additional-details-open" : "additional-details-closed"} nft={props.nft} nftMeta={props.nftMeta} defaultOpen={props.defaultAdditionalDetailsOpen ?? false} />;
      $[2] = props.defaultAdditionalDetailsOpen;
      $[3] = props.nft;
      $[4] = props.nftMeta;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
      t2 = <>{t0}{t1}</>;
      $[6] = t0;
      $[7] = t1;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  let t0;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  return t0;
}
function MemePageCardDescription(t0) {
  const $ = _c(4);
  const {
    nft
  } = t0;
  let t1;
  if ($[0] !== nft.description) {
    t1 = parseNftDescriptionToHtml(nft.description);
    $[0] = nft.description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <section className="tw-max-w-4xl tw-text-pretty tw-pb-3"><div className="tw-text-base tw-font-normal tw-text-iron-300" dangerouslySetInnerHTML={{
        __html: t1
      }} /></section>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function MemePageAdditionalDetailsAccordion(t0) {
  const $ = _c(28);
  const {
    nft,
    nftMeta,
    defaultOpen
  } = t0;
  const [isOpen, setIsOpen] = useState(defaultOpen);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-p-1.5 tw-transition-colors tw-duration-300 tw-ease-out ${isOpen ? "tw-bg-primary-500 tw-text-iron-100" : "tw-bg-iron-900 tw-text-iron-500 group-hover:tw-text-iron-100"}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <InformationCircleIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <span className={t2}>{t3}</span>;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-200">Additional details</span>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <span className="tw-flex tw-items-center tw-gap-3">{t4}{t5}</span>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-500 tw-transition tw-duration-200 group-hover:tw-text-iron-100 ${isOpen ? "tw-rotate-180 tw-text-iron-100" : ""}`;
  let t8;
  if ($[7] !== t7) {
    t8 = <ChevronDownIcon className={t7} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isOpen || $[10] !== t6 || $[11] !== t8) {
    t9 = <button type="button" aria-expanded={isOpen} onClick={t1} className="tw-group tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-gap-4 tw-border-0 tw-bg-transparent tw-px-0 tw-py-4 tw-text-left tw-text-iron-100 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-white">{t6}{t8}</button>;
    $[9] = isOpen;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `tw-grid tw-transition-[grid-template-rows,opacity] tw-duration-300 tw-ease-out ${isOpen ? "tw-grid-rows-[1fr] tw-opacity-100" : "tw-grid-rows-[0fr] tw-opacity-0"}`;
  const t11 = !isOpen;
  const t12 = !isOpen;
  const t13 = isOpen ? undefined : -1;
  const t14 = isOpen ? "tw-overflow-visible" : "tw-overflow-hidden";
  let t15;
  if ($[13] !== nft || $[14] !== nftMeta) {
    t15 = <MemePageArt show={true} nft={nft} nftMeta={nftMeta} />;
    $[13] = nft;
    $[14] = nftMeta;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t13 || $[19] !== t14 || $[20] !== t15) {
    t16 = <div aria-hidden={t11} inert={t12} tabIndex={t13} className={t14}>{t15}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t10 || $[23] !== t16) {
    t17 = <div className={t10}>{t16}</div>;
    $[22] = t10;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t17 || $[26] !== t9) {
    t18 = <section className="tw-mt-4 tw-border-x-0 tw-border-y tw-border-solid tw-border-iron-800">{t9}{t17}</section>;
    $[25] = t17;
    $[26] = t9;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
}
function _temp(current) {
  return !current;
}